class MFRLottieAnimation {
    constructor( index, element ) {
        this.$index = index;
        this.$element = $( element );

        this.selectors = {
            animation: ".lottie-animation-section__animation",
            title: ".lottie-animation-section__title",
            desc: ".lottie-animation-section__desc",
            line: ".lottie-animation-section__illustration-line",
            surtitle: ".lottie-animation-section__illustration-surtitle",
            illTitle: ".lottie-animation-section__illustration-title",
            cta: ".lottie-animation-section__illustration-cta",
            wrapper: ".lottie-animation-section__wrapper",
            indicator: ".lottie-animation-section__indicator",
            progress: ".lottie-animation-section__indicators-progress",
            indicatorInner: ".lottie-animation-section__indicators-inner"
        }

        this.lottieURL = this.$element.data( "lottie-url" );

        // this.animationARR = this.sampleARR;
        // console.log( this.$element.data( "json" ) );
        this.animationARR = this.$element.data( "json" ).data;
        this.scrollID = this.$element.data( "scroll-id" );
        this.currentIndex = -1;
        this.slideCount = this.animationARR.length;
        this.isAnimationLoaded = false;
        this.lastPos = window.mfrScroll.scroll.instance.scroll.y;
        this.scrollTriggers;
        this.top = this.$element.get(0).getBoundingClientRect().top;
        this.lottieAnimated = false;
        this.maxProgress = 80;
        this.points = this.setPoints();
        this.changeTextTimeout;

        if ( !Shopify.designMode ) {
            this.init();
        }
    }

    init() {
        this.$animation = this.$element.find( this.selectors.animation );
        this.$wrapper = this.$element.closest( this.selectors.wrapper );
        this.$title = this.$element.find( this.selectors.title );
        this.$desc = this.$element.find( this.selectors.desc );
        this.$line = this.$element.find( this.selectors.line );
        this.$surtitle = this.$element.find( this.selectors.surtitle );
        this.$illTitle = this.$element.find( this.selectors.illTitle );
        this.$cta = this.$element.find( this.selectors.cta );
        this.$indicator = this.$element.find( this.selectors.indicator );
        this.$progress = this.$element.find( this.selectors.progress );
        this.$indicatorInner = this.$element.find( this.selectors.indicatorInner );

        // this.disableSmoothScroll();
        this.initializeLottie();
        this.updateIndicators();
    }

    initializeLottie() {
        if( typeof lottie === "undefined" || !this.lottieURL ) return;

        this.animation = lottie.loadAnimation({
            container: this.$animation.get(0),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: this.lottieURL
        });
        this.animation.pause();
        this.animation.addEventListener( 'DOMLoaded',() => {
            this.animation.stop()
            this.isAnimationLoaded = true;
            this.initializeScrollEvents();
        } );
        window.anim = this.animation;

        if( !$( "html" ).hasClass( "has-scroll-smooth" ) )
            this.$element.css( "top", $( "header.header" ).height() );

            this.$indicatorInner.css( "height", `${this.maxProgress}%` )
    }

    setSlide( index, reverse ) {
        let transition;
        const anim = this.animation;

        this.currentIndex = index;

        // if( reverse )

        // if( this.lottieAnimated && index < 0 ) {
        //     this.currentIndex = 0;

        //     //continue scrolling
        //     if( $( "html" ).hasClass( "has-scroll-smooth" ) )
        //         window.mfrScroll.stop();

        //     return;
        // }

        if( !reverse) {
            transition = [this.animationARR[index].transition[0], this.animationARR[index].transition[1]];
            this.animateLottie( transition, this.animationARR[index].loop, reverse, index );
        }
        else {
            let loop = ( index < 0 ) ? 0 : [].concat(this.animationARR[index].loop).reverse();
            transition = [this.animationARR[index + 1].transition[1], this.animationARR[index + 1].transition[0]];
            this.animateLottie( transition, loop, reverse, index )
        }
    }

    animateLottie( transition, loop, reverse, index ) {
        if( !transition || !this.isAnimationLoaded ) return;
        this.animation.removeEventListener( "loopComplete" );
        this.animation.playSegments(transition, true);

        // anim.setSpeed(2);
        this.updateTexts( index );
        this.updateIndicators();
        this.$element.toggleClass( "last-slide", this.currentIndex == this.slideCount - 1 );
        this.$wrapper.toggleClass( "last-slide", this.currentIndex == this.slideCount - 1 );

        this.$element.toggleClass( "second-last-slide", this.currentIndex == this.slideCount - 2 );
        this.$wrapper.toggleClass( "second-last-slide", this.currentIndex == this.slideCount - 2 );

        this.animation.addEventListener( "loopComplete", () => {

            //continue scrolling
            // if( $( "html" ).hasClass( "has-scroll-smooth" ) )
            //     window.mfrScroll.stop();

            this.animation.playSegments(loop,true);
            this.animation.removeEventListener( "loopComplete" );
            // anim.setSpeed(1);
            
            // if( loop == 0 ) {
            //     this.animation.goToAndStop(0, true)
            //     this.currentIndex = -1;
            //     return;
            // }

            // if( reverse )
            //     this.currentIndex--;
            // else
            //     this.currentIndex++;

            this.lottieAnimated = true;
        } );
    }

    initializeScrollEvents() {
        if( !this.isAnimationLoaded ) return;
        window.mfrScroll.on('scroll', (args) => {
            // if(typeof args.currentElements[this.scrollID] === 'object') {
            //     const progress = args.currentElements[this.scrollID].progress;
            //     const percentage = progress * 100;
            //     // const viewportPercentage = this.$element.height() /  this.$wrapper.height() * 100;
            //     const viewportPercentage = 100 / this.slideCount;
            //     let index = Math.min(this.slideCount - 1,(percentage/viewportPercentage).toFixed(0));
            const progress = this.getStickyProgress();
            const direction = args.direction;
            const scrollingIndex = this.getPassedPointIndex(progress);

            if( progress <= 0 ) {
                this.updateProgress(0);
                return;
            }
            else if ( progress > 100 ) {
                this.updateProgress( 100 );
                return;
            }
            
            this.updateProgress(progress);
            
            // if( window.scrollingToAnchor ) {
            //     const destination = $( window.location.hash ).get(0).getBoundingClientRect().top;
            //     if( destination > this.top ) {
            //         this.currentIndex = this.slideCount - 2;
            //         this.setSlide( this.currentIndex + 1, false );
            //     }
            // }
            // else {
                if( direction == "down" ) {
                    if( scrollingIndex != this.currentIndex ) {
                        this.setSlide( scrollingIndex, false );
                    }
                }
                else if( direction == "up" ) {
                    if( scrollingIndex != this.currentIndex ) {
                        this.setSlide( scrollingIndex, true );
                    }
                }
                // if ( args.direction == "down" ) {
                //     if( this.currentIndex <= this.slideCount - 2 ) {
                //         // if( this.currentIndex == index ) return;

                //         //stop scrolling
                //         if( $( "html" ).hasClass( "has-scroll-smooth" ) )
                //             window.mfrScroll.stop();

                //         this.setSlide( this.currentIndex + 1, false );
                //     }
                // }
                // else {
                //     if( this.currentIndex >= 0 ) {

                //         //stop scrolling
                //         if( $( "html" ).hasClass( "has-scroll-smooth" ) )
                //             window.mfrScroll.stop();

                //         this.setSlide( this.currentIndex - 1, true );
                //     }
                // }
            // }
            // }
        });
    }

    getHowFarLevel(min, max, firstNumber, lastNumber) {
        const distance = Math.abs(lastNumber - firstNumber);
        const totalRange = max - min;
        const percentage = distance / totalRange;
        const factor = 2;
        const level = Math.ceil(percentage * factor);
        return level;
    }

    changeText( element, text ) {
        element.addClass( "is-active" );
        if( element.find( "span,a" ).html() == text ) return;
        element.removeClass( "is-active" );
        element.addClass( "animating" );
        const timeout = setTimeout( () => {
            element.find( "span,a" ).html( text );
            element.addClass( "is-active" );
            element.removeClass( "animating" );
        }, 400 );
    }

    updateTexts( index ) {
        if( typeof this.animationARR[index] === 'undefined' ) {
            this.changeText( this.$title, "" );
            this.changeText( this.$desc, "" );
            this.changeText( this.$surtitle, "" );
            this.changeText( this.$illTitle, "" );
            this.updateLine( 0 );
            this.updateCTA( "", "" );
        }
        else {
            this.changeText( this.$title, this.animationARR[index].title );
            this.changeText( this.$desc, this.animationARR[index].desc );
            this.changeText( this.$surtitle, this.animationARR[index].illustration.surtitle );
            this.changeText( this.$illTitle, this.animationARR[index].illustration.title );
            this.updateLine( this.animationARR[index].illustration.line );
            this.updateCTA( this.animationARR[index].illustration.ctaURL, this.animationARR[index].illustration.ctaLabel );
        }
    }

    updateLine( value ) {
        this.$line.toggleClass( "lottie-animation-section__illustration-line--hide", value == 0 );
        this.$line.css( "width", `${value}%` );
    }

    updateCTA( url, label ) {
        const element = this.$cta;
        const text = label;
        element
            .find( "a" )
            .attr( "href", url );

        element.addClass( "is-active" );
        if( element.find( "span,a > span" ).text() == text ) return;
        element.removeClass( "is-active" );
        if( text == "" || element.hasClass( "animating" ) ) return;
        element.addClass( "animating" );
        setTimeout( () => {
            if( url )
                element
                    .addClass( "lottie-animation-section__illustration-cta--button" )
                    .find( "a" ).addClass( "button" );
            else
                element
                    .removeClass( "lottie-animation-section__illustration-cta--button" )
                    .find( "a" ).removeClass( "button" );

            element.find( "span,a > span" ).text( text );
            element.addClass( "is-active" );
            element.removeClass( "animating" );
        }, 400 );
    }

    updateIndicators() {
        this.$indicator.removeClass( "is-active" );
        
        if( !this.$element.find( `${this.selectors.indicator}[data-index="${this.currentIndex}"]` ).length ) return;
        this.$element.find( `${this.selectors.indicator}[data-index="${this.currentIndex}"]` ).addClass( "is-active" );
    }

    getStickyProgress() {
        const stickyElement = this.$element;
        const parentContainer = this.$wrapper;
        const parentTop = parentContainer.offset().top;
        const stickyTop = stickyElement.offset().top;
        const stickyProgress = (stickyTop - parentTop) / (parentContainer.outerHeight() - stickyElement.outerHeight());

        // Add a check to ensure that progress is not greater than 1
        if (stickyProgress >= 1 || window.pageYOffset >= parentTop + parentContainer.outerHeight() - stickyElement.outerHeight()) {
            return 100;
        }
        else if (stickyProgress < 0) {
            return 0;
        }
        else {
            return Math.ceil(stickyProgress * 100);
        }
    }

    updateProgress( percentage ) {
        this.$progress.css( "--progress-percentage", `${percentage}%` );
    }

    setPoints() {
        let points = [];
        $.each( this.animationARR, ( i, e ) => points.push( (i * (this.maxProgress / ( this.animationARR.length - 1 ))).toFixed(0) ) );
        return points;
    }

    getPassedPointIndex(value) {
        let points = this.points;
        let index = 0;

        for (let i = 0; i < points.length; i++) {
            if (value < points[i]) {
                index = i - 1;
                break;
            } else if (value === points[i]) {
                index = i;
                break;
            }
            index = i;
        }

        return index;
      }
}